import { useContext } from 'react';

import { ReportContainerContext } from './ReportContainerContext';

/**
 * Hook to access the ReportContainer
 */
const useReportContainer = () => {
  const context = useContext(ReportContainerContext);
  if (!context) {
    throw new Error('useReportContainer must be used within a ProjectReportContainerContext');
  }

  return context;
};

export default useReportContainer;
